import request from "../services/HTTPClient";
import { requestMethods, API } from "../constants";

function GetAll() {
  return request({
    url: API.ORDERS_EXPRESS.GET_ALL,
    method: requestMethods.GET,
  });
}

function Create(data) {
  return request({
    url: API.ORDERS.ORDERS_EXPRESS,
    method: requestMethods.POST,
    data,
  });
}

const OrderExpressService = {
  GetAll,
  Create
};

export default OrderExpressService;
